import { RSAA } from 'redux-api-middleware';
import localStorage from 'local-storage';

import { defaultTenant, hasTenantHeader } from 'config/tenant';

import { store } from '../store';

export default function () {
  return function (next) {
    return function (action) {
      const callApi = action[RSAA];
      // Check if this action is a redux-api-middleware action.
      if (callApi) {
        // The axios client (src/config/axios.jsx) reads the token from
        // localStorage while this path read it from the redux store, so the two
        // could disagree. Prefer the store, fall back to localStorage, and send no
        // Authorization header at all rather than a tokenless "Bearer ".
        const jwt = store.getState().user.jwt || localStorage.get('token');

        callApi.headers = Object.assign(
          {},
          { 'Content-Type': 'application/json' },
          jwt ? { Authorization: `Bearer ${jwt}` } : null,
          callApi.headers,
        );

        // Never overwrite a tenant the action names itself; see config/tenant.jsx.
        const tenant = hasTenantHeader(callApi.headers)
          ? null
          : defaultTenant({ signedIn: Boolean(jwt) });
        if (tenant) {
          callApi.headers.TenantId = tenant;
        } else if (tenant === undefined && jwt) {
          // Signed in with no usable branch: the header is silently absent, which is
          // hard to tell apart from an auth problem at the API. Signed out it is
          // expected, because the API resolves those requests itself.
          console.warn(
            `[apiAuthInjector] no TenantId for branch ${JSON.stringify(
              localStorage.get('branch'),
            )}; request sent without a tenant`,
          );
        }
      }

      // Pass the FSA to the next action.
      return next(action);
    };
  };
}
